import useApi from '../../../services/useApi'
import useFilters from '../../../hook/useFilters'
import moment from 'moment'
import {useState} from 'react'

const useGetCustomerGroupReport = () => {
  const Api = useApi()
  const [dateRange] = useState(() => JSON.parse(localStorage.getItem('selectedDateRange') || '{}'))

  const initialFilters = {
    sort_by: 'total_discount/-1',
    start_date: dateRange?.startDate ?? moment().subtract(3, 'months').format('YYYY-MM-DD'),
    end_date: dateRange?.endDate ?? moment().format('YYYY-MM-DD'),
    customer_group_id: '',
  }

  const {filters, onSortingChange, onDateChange, setMultipleFilters} = useFilters(initialFilters, {
    sortType: 'number',
  })

  const {data: response, isFetching} = Api.useGetQuery(
    '/analytics/order-discount/report/customer-groups',
    {
      queryId: 'discount-customer-group-report',
      filters,
    }
  )

  const onChangeCustomerGroupFilter = (values: any[]) => {
    setMultipleFilters({
      customer_group_id: values?.map((item: {value: string}) => item?.value).join(','),
      page: 1,
    })
  }

  return {
    reportData: response?.data || [],
    isLoading: isFetching,
    filters,
    onSortingChange,
    onDateChange,
    onChangeCustomerGroupFilter,
  }
}

export default useGetCustomerGroupReport
